import notisphereServices from '../../../services/notisphere/email'
import Editor from '@tinymce/tinymce-vue'

export default {
    components: {
        Editor
    },
    data() {
        return {
            item: [],
            content: null,
            contentType: 'Login',
            isDisabled: false,
            editorConfig: {
                height: 800,
                plugins: 'lists link image table code help wordcount advlist autolink charmap print preview anchor searchreplace visualblocks fullscreen insertdatetime media paste fontselect fontsizeselect',
                toolbar: 'undo redo | formatselect fontselect fontsizeselect | bold italic underline alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
                branding: false
            }
        }
    },
    created(){
        this.cancel()
    },
    methods: {
        save() {
            let formData = new FormData()
            formData.append('content', this.content ? this.content.trim() : '')
            formData.append('contentType', this.contentType ? this.contentType : '')
            notisphereServices.contentManagement(formData).then(resp => {
                if (!resp.error) {
                    this.$emit('onCompleted', 'UPDATE')
                    this._showToast('Updated successfully!')
                    this.cancel()
                }
            })
        },
        cancel(){
            notisphereServices.getcontentManagement(this.contentType).then((resp) => {
                if (!resp.error) {
                    this.content = resp.data.d.content
                }
            })
        }
    }
}